import React from "react";
import { Result, Typography, Layout, Button } from "antd";
import { ToolOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const CustomizedMaintenance: React.FC = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#f0f2f5" }}>
      <Content
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <Result
          icon={<ToolOutlined style={{ fontSize: 80, color: "#1890ff" }} />}
          title={<Title level={2}>Site en maintenance</Title>}
          subTitle={
            <Paragraph style={{ maxWidth: 500 }}>
              Nous effectuons actuellement des opérations de maintenance pour
              améliorer votre expérience. <br />
              <Text strong>Merci de votre patience.</Text>
            </Paragraph>
          }
          extra={
            <Button type="primary" onClick={handleRefresh}>
              Rafraîchir la page
            </Button>
          }
        />
        <Text type="secondary" style={{ marginTop: 16 }}>
          &copy; {new Date().getFullYear()} IN Concept – Tous droits réservés
        </Text>
      </Content>
    </Layout>
  );
};

export default CustomizedMaintenance;
